import { businessService } from '@/pages/Business/services/business.service';
import type {
  BatchTransition,
  TransitionIncludedStatus,
  ValidateShippingArgs,
  ValidateShippingResponse,
  ValidateShippingBatchArgs,
  ValidateShippingBatchItem,
  ExecuteBatchBulkArgs,
  ExecuteBatchBulkResponse,
} from '../models';

const batchCheckpointsApi = businessService.injectEndpoints({
  endpoints: (builder) => ({
    getBatchTransitions: builder.query<BatchTransition[], void>({
      query: () => ({
        url: '/transitions/batch',
      }),
      providesTags: ['BatchCheckpointsTransition'],
    }),

    getTransitionIncludedStatuses: builder.query<TransitionIncludedStatus[], string>({
      query: (transitionId) => ({
        url: '/transition-included-statuses',
        params: { transitionId },
      }),
    }),

    validateBatchShipping: builder.mutation<ValidateShippingResponse, ValidateShippingArgs>({
      query: ({ transitionId, shippingNumber, mode, logisticOperatorId }) => ({
        url: '/transitions/validate-shipping',
        method: 'POST',
        params: { ...(mode && { mode }) },
        headers: { ...(logisticOperatorId && { 'x-logistic-operator': logisticOperatorId }) },
        body: { transitionId, shippingNumber },
      }),
    }),

    validateShippingBatch: builder.mutation<ValidateShippingBatchItem[], ValidateShippingBatchArgs>({
      query: ({ transitionId, codes, mode, logisticOperatorId, visitId, parentId }) => ({
        url: '/transitions/validate-shipping-batch',
        method: 'POST',
        params: { mode },
        headers: { ...(logisticOperatorId && { 'x-logistic-operator': logisticOperatorId }) },
        body: {
          transitionId,
          codes,
          ...(visitId && { visitId }),
          ...(parentId !== undefined && { parentId }),
        },
      }),
    }),

    executeBatchTransitionBulk: builder.mutation<ExecuteBatchBulkResponse, ExecuteBatchBulkArgs>({
      query: ({ transitionId, codes }) => ({
        url: `/transitions/execute-batch-bulk/${transitionId}`,
        method: 'POST',
        body: { codes },
      }),
      invalidatesTags: ['BatchCheckpoints'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetBatchTransitionsQuery,
  useGetTransitionIncludedStatusesQuery,
  useValidateBatchShippingMutation,
  useValidateShippingBatchMutation,
  useExecuteBatchTransitionBulkMutation,
} = batchCheckpointsApi;
